
const project_name = "GREENSUN"

class StorageHelper { 
    constructor() {
        if (StorageHelper.instance) {
            return StorageHelper.instance;
          }
        if (!localStorage.getItem(project_name)) {
            const storage = {};
            localStorage.setItem(project_name, JSON.stringify(storage));
        }

        StorageHelper.instance = this;
    }
    get(key){
        const dataStr = localStorage.getItem(project_name);
        const data = JSON.parse(dataStr)
        return data[key]
    }
    set(key, value){
        if(value == null || value === undefined){
            // throw new Error('value for localstorage cannotbe null or undefined')
            console.error('value for localstorage cannotbe null or undefined')
        }
        const dataStr = localStorage.getItem(project_name) ?? {}
        const data = JSON.parse(dataStr )
        data[key] = value
        const newData = JSON.stringify(data)
       localStorage.setItem(project_name,newData);
    }
    remove(key){
        const dataStr = localStorage.getItem(project_name) ?? {}
        let data = JSON.parse(dataStr )
        delete data[key] 
        const newData = JSON.stringify(data)
       localStorage.setItem(project_name,newData); 
    }
    clean(){
        localStorage.setItem(project_name, "{}");

    }
}


export const Storage = new StorageHelper();
export const Items = {
    logedInUser:"logedInUser",
    clinicId:"clinicId"

}
